// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table th.menu,\n.el-table td.menu {\n  width: 6.5em;\n}", ""]);
// Exports
module.exports = exports;
